import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
} from 'firebase/storage';
import { getFirebaseStorage } from '../firebase/index';

const dataUrlToBlob = (dataUrl: string): { blob: Blob; contentType: string } => {
  const matches = dataUrl.match(/^data:(.+);base64,(.*)$/);
  if (!matches || matches.length !== 3) {
    throw new Error('Invalid data URL');
  }
  const contentType = matches[1];
  const byteCharacters = atob(matches[2]);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return { blob: new Blob(byteArrays, { type: contentType }), contentType };
};

const generateMediaPath = (workspaceId: string, extension: string) => {
  const timestamp = Date.now();
  const unique = Math.random().toString(36).slice(2, 10);
  const cleanExtension = extension ? extension.replace(/^\./, '') : 'bin';
  return `workspaces/${workspaceId}/media/${timestamp}-${unique}.${cleanExtension}`;
};

export interface UploadMediaResult {
  downloadUrl: string;
  storagePath: string;
  contentType: string;
}

export const uploadMediaDataUrl = async (
  workspaceId: string,
  dataUrl: string
): Promise<UploadMediaResult> => {
  const { blob, contentType } = dataUrlToBlob(dataUrl);
  const storage = await getFirebaseStorage();
  const extension = contentType.split('/')[1] ?? 'bin';
  const storagePath = generateMediaPath(workspaceId, extension);
  const storageRef = ref(storage, storagePath);
  await uploadBytes(storageRef, blob, { contentType });
  const downloadUrl = await getDownloadURL(storageRef);
  return { downloadUrl, storagePath, contentType };
};

export const deleteMediaByPath = async (storagePath: string) => {
  const storage = await getFirebaseStorage();
  const storageRef = ref(storage, storagePath);
  await deleteObject(storageRef);
};
